export const UPDATE_FIELDS_CONTACT = 'UPDATE_FIELDS_CONTACT';
export const GET_LOCAL_FIELDS = 'GET_LOCAL_FIELDS';



export const updatefieldscontact = (data) => {
    return {
        type: UPDATE_FIELDS_CONTACT,
        data: data
    }
}

export const getLocalFieldsValue = (data) => {

    return {
        type: GET_LOCAL_FIELDS,
        data: data
    }

}


// WEBPACK FOOTER //
// ./src/Services/Contact/action.js